export const MAX_DIGITS_FOR_BID_AMOUNTS = 10;
export const MEDIUM_BID_TEXT_LENGTH = 8;
export const LARGE_BID_TEXT_LENGTH = 10;
